import UnsurePenguinSvg from "./unsure.svg";

export function UnsurePenguin() {
  return <UnsurePenguinSvg />;
}
